<!--
  列表页的顶部导航返回按钮
-->
<template>
  <el-button icon="el-icon-arrow-left" class="m-r-10i" circle @click="backOrTo(backPath)"></el-button>
</template>

<script>
export default {
  props: {
    /**
     * 当没有返回历史时使用
     */
    backPath: {
      type: String,
      default: '/'
    },
    /**
     * 当返回到 backPath 时使用，主要是让返回动作更加清晰
     */
    backName: {
      type: String,
      default: ''
    }
  },
  computed: {
    /**
     * 上一路由的名字
     * 如在订单页打开用户的详情信息，返回就会显示完整的「返回订单详情」
     *
     * @returns {string} 路由名称
     */
    prevRouterName() {
      return this.$store.state.app.prevRouterName
    },
    /**
     * 是否显示返回的路径的名字
     *
     * @returns {boolean} 是否显示
     */
    showBackName() {
      return this.backName !== ''
    }
  },
  methods: {
    /**
     * 判断返回路径 与 routerPath 是否相同
     * 如果是，则一般使用 router.go(-1)直接返回到上一层页面，能保持参数不变
     *
     * @param {string} routerPath 对比的路由的路径
     * @returns {boolean} 是否返回到指定的路径
     */
    isBackToPath(routerPath) {
      // 如果是与指定的路径相同
      return this.$store.state.app.prevRouterPath === routerPath
    },
    /**
     * 返回或者跳转到指定页面
     * 当没有返回时，就跳转到指定页面
     *
     * @param {string} path 路由路径
     */
    backOrTo(path) {
      if (history.length <= 2) {
        this.$router.push(path)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.back-btn {
  font-size: 14px;
  color: #8e8e8e;
}
</style>
